module.exports = __webpack_public_path__ + "static/Timberland-Sig-01-1d7f8358f8506d5b943162d444dff98d.svg";